import dayjs from '@schuelerhilfe/shared/src/utils/dayjs';

export interface DataLayerTimestamp {
  date: string;
  time: string;
}

export const getDataLayerTimestamp = (): DataLayerTimestamp => {
  const now = dayjs();

  return {
    date: now.format('YYYY-MM-DD'),
    time: now.format('YY-MM-DD HH:mm:ss'),
  };
};
